import axios from 'axios';

export interface ChatConversation {
  id: number;
  type: string;
  statut: string;
  user: {
    id: number;
    nom: string;
    prenom: string;
    email: string;
    telephone: string;
    avatar: string | null;
  } | null;
  agent: {
    id: number;
    nom: string;
    prenom: string;
    username: string;
  } | null;
  dernierMessage: {
    texte: string;
    date: string;
    qui: 'user' | 'bot';
  } | null;
  messagesCount: number;
  unreadCount?: number; // Nombre de messages non lus
  created_at: string;
  updated_at: string;
}

export interface ChatMessage {
  id: number;
  conversationId: number;
  texte: string;
  metadata: any;
  agent: {
    id: number;
    nom: string;
    prenom: string;
    username: string;
  } | null;
  date: string;
  statut: string;
  qui: 'user' | 'bot';
}

class ChatService {
  async getConversations(params?: {
    statut?: string;
    type?: string;
    search?: string;
    sortColumn?: string;
    sortDir?: string;
  }): Promise<ChatConversation[]> {
    const response = await axios.get('/backoffice/chats/list', { params });
    // La réponse peut être { data: [...] } ou directement un tableau
    return response.data.data || response.data;
  }

  async getUnreadCount(): Promise<{ total: number; byConversation: Record<number, number> }> {
    const response = await axios.get('/backoffice/chats/unread-count');
    return response.data.data;
  }

  async markAsRead(conversationId: number): Promise<void> {
    await axios.post(`/backoffice/chats/${conversationId}/mark-read`);
  }

  async getConversation(id: number): Promise<ChatConversation> {
    const response = await axios.get(`/backoffice/chats/get/${id}`);
    return response.data;
  }

  async getMessages(conversationId: number): Promise<ChatMessage[]> {
    const response = await axios.get(`/backoffice/chats/${conversationId}/messages`);
    return response.data;
  }

  async sendMessage(conversationId: number, texte: string): Promise<ChatMessage> {
    const response = await axios.post('/backoffice/chats/messages', {
      conversation_id: conversationId,
      texte,
    });
    return response.data.data;
  }

  async updateStatus(conversationId: number, statut: 'open' | 'closed' | 'pending'): Promise<void> {
    await axios.post(`/backoffice/chats/${conversationId}/status`, { statut });
  }
}

export default new ChatService();
